import { BaseApi } from '@/main/baseApi';

import { API_ND_AREA, NAME, DependentTableNames, PART_PRICING_LOG, WEIGHTED_AVG } from './constants';

class NdSkladProvider extends BaseApi {
	constructor() {
		super(API_ND_AREA, NAME);
	}

	schemaUrl(tableName: DependentTableNames) {
		switch (tableName) {
			case PART_PRICING_LOG:
				return `/${API_ND_AREA}/${NAME}/PricilingListSchema`;
			case WEIGHTED_AVG:
				return `/${API_ND_AREA}/${NAME}/WeightedAveragePriceSchema`;
			default:
				return `/${this.area}/${this.controller}/${tableName}Schema`;
		}
	}

	tableUrl(tableName: DependentTableNames) {
		switch (tableName) {
			case PART_PRICING_LOG:
				return `/${API_ND_AREA}/${NAME}/PricilingListRows`;
			case WEIGHTED_AVG:
				return `/${API_ND_AREA}/${NAME}/WeightedAveragePriceRows`;
			default:
				return `/${this.area}/${this.controller}/${tableName}Rows`;
		}
	}

	disponibilitaSkladSchema() {
		return this.fetch(`/${API_ND_AREA}/${NAME}/DispoDleSkladuSchema`);
	}

	disponibilitaSkladRows(filter: object) {
		return this.fetch(`/${API_ND_AREA}/${NAME}/DispoDleSkladuRows`, filter);
	}

	disponibilitaZakazkaSchema() {
		return this.fetch(`/${API_ND_AREA}/${NAME}/DispoDleZakazky/Schema`);
	}

	disponibilitaZakazkaRows(filter: object) {
		return this.fetch(`/${API_ND_AREA}/${NAME}/DispoDleZakazky/Rows`, filter);
	}

	async getPartDetails(partNo: string, brand: string, orderType: string, supplierId: number, warehouseId: number | null) {
		return this.fetch(`/${API_ND_AREA}/${NAME}/GetPartDetails?partNo=${partNo}&brand=${brand}&orderType=${orderType}&supplierId=${supplierId}&warehouseId=${warehouseId}`);
	}

	zmenaPC() {
		return this.fetch(`/${API_ND_AREA}/${NAME}/ZmenaPC`);
	}

	prumernaSkladovaPc(filter: object) {
		return this.fetch(`/${API_ND_AREA}/${NAME}/PrumernaSkladovaPc`, filter);
	}

	async disponibilitaSpc(filter: any) {
		return this.fetch(`/${API_ND_AREA}/${NAME}/DisponibilitaSpc`, filter);
	}

	async entityByVyrobekndOznNdNrSkladOzn(filter: any) {
		return this.fetch(`/${API_ND_AREA}/${NAME}/`, filter);
	}

	async nahradyPredchudceRowsCount(filter: any) {
		return this.fetch(`/${API_ND_AREA}/${NAME}/NahradyPredchudceRowsCount`, filter);
	}

	async nahradyNasledovnikRowsCount(filter: any) {
		return this.fetch(`/${API_ND_AREA}/${NAME}/NahradyNasledovnikRowsCount`, filter);
	}

	async korekceStavu(data: object) {
		return this.post(`/${API_ND_AREA}/${NAME}/KorekceStavu`, data);
	}

	async saveSparePartReminders(data: object) {
		return this.post(`/${API_ND_AREA}/${NAME}/SaveSparePartReminders`, data);
	}

	inventoryAdjReqExists(zaznamId: number) {
		return this.fetch(`/${API_ND_AREA}/${NAME}/InventoryAdjReqExists`, { zaznamId });
	}

	existingRequestData(zaznamId: number) {
		return this.fetch(`/${API_ND_AREA}/${NAME}/ExistingRequestData?zaznamId=${zaznamId}`);
	}

	async inventoryAdjusments(data: object) {
		return this.post(`/${API_ND_AREA}/${NAME}/InventoryAdjusments`, data);
	}

	disponsibilitaSPC(filter: any) {
		return this.fetch(`/${API_ND_AREA}/${NAME}/DisponibilitaSpc`, filter);
	}

	getNdSklad({ vyrobekndOzn, ndNr, skladOzn }: { vyrobekndOzn: string, ndNr: string, skladOzn: number }) {
		return this.fetch(`${this.apiPath}getNdSklad`, { vyrobekndOzn, ndNr, skladOzn });
	}

	ndSkladForVydejNd(ndskladId: number) {
		return this.fetch(`${this.apiPath}ndSkladForVydejNd`, { id: ndskladId });
	}

	async sendEmailNotification(dto: any) {
		return this.post('/Nd/PartsInventoryAdjustments/SendMailNotification', dto);
	}

	async sendNotification(dto: any) {
		return this.post(`/${API_ND_AREA}/${NAME}/SendNotification`, dto);
	}

	async checkIfExpiryAvailable(NdNr: string, skladOzn: number ) {
		return this.fetch(`/${API_ND_AREA}/${NAME}/CheckIfExpiryAvailable/?NdNr=${NdNr}&skladOzn=${skladOzn}`);
	}

	async isPartBlock(ndnr: string, VyrobekndOzn: string, quantity: number) {
		return this.fetch(`${this.apiPath}IsPartBlock`, { ndnr, VyrobekndOzn, quantity });
	}

	async isPartAvailableInSklad(ZbozidruhOzn: string) {
		return this.fetch(`${this.apiPath}IsPartAvailableInSklad`, { ZbozidruhOzn });
	}

	async getConversionUnitsForPart(ndnr: string, skladOzn: number, vyrobekndOzn: string): Promise<Record<string, any>> {
		return this.fetch(`${this.apiPath}GetConversionUnitsForPart`, { ndnr, skladOzn, vyrobekndOzn });
	}

	async getAvailableQuantityByOrderType(partNo: string, brand: string, orderType: string, skladOzn: number): Promise<Record<string, any>> {
		return this.fetch(`${this.apiPath}GetAvailableQuantityByOrderType`, { partNo, brand, orderType, skladOzn });
	}

	async deletePart(zaznamId: number, ndnr: string, vyrobekndOzn: string, skladOzn: number) {
		return this.delete(`/${API_ND_AREA}/${NAME}/DeletePart/?zaznamId=${zaznamId}&ndnr=${ndnr}&vyrobekndOzn=${vyrobekndOzn}&skladOzn=${skladOzn}`);
	}
}

export const apiProvider = new NdSkladProvider();
